import { render, staticRenderFns } from "./addWalletAddress.vue?vue&type=template&id=e66af546&scoped=true"
import script from "./addWalletAddress.vue?vue&type=script&lang=js"
export * from "./addWalletAddress.vue?vue&type=script&lang=js"
import style0 from "./addWalletAddress.vue?vue&type=style&index=0&id=e66af546&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66af546",
  null
  
)

export default component.exports